import React from "react";
import { useLanguage } from "../../context/LanguageContext";

const FLAGS = {
  en: "🇬🇧",
  zh: "🇨🇳",
};

const LABELS = {
  en: "EN",
  zh: "中文",
};

const NEXT = {
  en: "zh",
  zh: "en",
};

export default function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();
  const next = NEXT[lang];

  return (
    <button
      id="language-switcher"
      onClick={() => setLang(next)}
      title={lang === "en" ? "切换到中文" : "Switch to English"}
      style={{
        background: "rgba(255,255,255,0.12)",
        border: "1px solid rgba(255,255,255,0.35)",
        borderRadius: "24px",
        padding: "4px 12px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        color: "white",
        fontSize: "0.85rem",
        fontWeight: "600",
        letterSpacing: "0.04em",
        backdropFilter: "blur(8px)",
        transition: "background 0.2s, transform 0.15s",
        whiteSpace: "nowrap",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.25)";
        e.currentTarget.style.transform = "scale(1.05)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.12)";
        e.currentTarget.style.transform = "scale(1)";
      }}
    >
      <span>{FLAGS[next]}</span>
      <span>{LABELS[next]}</span>
    </button>
  );
}
